var _style, _g, _g2, _g3, _g4, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _polygon, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _rect35, _rect36, _polygon8, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _polygon9, _polygon10;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    className: "nav-logo",
    x: "0px",
    y: "0px",
    width: "190px",
    height: "36px",
    viewBox: "0 0 190 36",
    style: {
      enableBackground: "new 0 0 190 36"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#A1A0A0;}\n\t.st1{fill:#DDDBDB;}\n\t.st2{fill:#CFCFCF;}\n\t.st3{fill:#767576;}\n\t.st4{fill:#727272;}\n\t.st5{fill:#E5E5E5;}\n\t.st6{fill:#B7B7B7;}\n\t.st7{fill:#999999;}\n\t.st8{fill:#C1C1C1;}\n\t.st9{fill:#A5A5A5;}\n\t.st10{fill:#CCCCCC;}\n\t.st11{fill:#CECECE;}\n\t.st12{fill:#D8D8D8;}\n\t.st13{fill:#A8A8A8;}\n\t.st14{fill:#8C8C8C;}\n\t.st15{fill:#7F7F7F;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "30.6,18 39.2,18 39.2,8.3 30.6,9.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "47.9,18 56.6,18 56.6,9.3 47.9,8.3  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.5,
    y: 8.3,
    className: "st0",
    width: 8.7,
    height: 9.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "0.4,18 9.1,18 9.1,9.3 0.4,8.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "17.8,18 26.5,18 26.5,9.3 17.8,8.3  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.1,
    y: 8.3,
    className: "st0",
    width: 8.7,
    height: 9.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.4,
    y: 8.3,
    className: "st0",
    width: 8.7,
    height: 9.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.7,
    y: 8.3,
    className: "st0",
    width: 8.7,
    height: 9.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "172.2,13.7 172.2,8.3 163.5,8.3 163.5,18 172.2,18 172.2,22.3 180.9,22.3 180.9,13.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "82,8.3 73.3,8.3 73.3,18 82,18 90.7,18 90.7,13.1 86.9,9.3  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 30.6,
    y: 25.7,
    className: "st1",
    width: 8.7,
    height: 9.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.9,
    y: 25.7,
    className: "st1",
    width: 8.7,
    height: 9.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.5,
    y: 25.7,
    className: "st1",
    width: 8.7,
    height: 9.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.4,
    y: 25.7,
    className: "st1",
    width: 8.7,
    height: 9.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.1,
    y: 25.7,
    className: "st1",
    width: 8.7,
    height: 9.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "142.1,26.7 133.4,25.7 133.4,35.3 142.1,35.3 150.8,35.3 159.5,35.3 159.5,26.7 150.8,26.7  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.3,
    y: 25.7,
    className: "st1",
    width: 8.7,
    height: 9.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "180.9,26.7 172.2,26.7 163.5,25.7 163.5,35.3 172.2,35.3 180.9,35.3 189.6,35.3 189.6,26.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "90.7,25.7 85.8,26.7 90.7,31.5 94.5,35.4 99.4,35.4 99.4,25.7  "
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "39.2,18 30.6,17 30.6,26.7 39.2,26.7 47.9,26.7 56.6,26.7 56.6,17 47.9,18  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.5,
    y: 17,
    className: "st2",
    width: 8.7,
    height: 9.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "9.1,18 0.4,17 0.4,26.7 9.1,26.7 17.8,26.7 26.5,18 17.8,17 17.8,18  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.1,
    y: 17,
    className: "st2",
    width: 8.7,
    height: 9.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.4,
    y: 17,
    className: "st2",
    width: 8.7,
    height: 9.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.5,
    y: 17,
    className: "st2",
    width: 8.7,
    height: 9.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "90.7,17 89.7,17 82,17 73.3,17 73.3,26.7 82,26.7 82,22.9 85.8,26.7 90.7,26.7 90.7,26.7 90.7,26.7 99.4,26.7 99.4,17  "
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "39.2,0.7 30.6,9.3 39.2,9.3 47.9,9.3 56.6,9.3 47.9,0.7  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.5,
    y: 0.7,
    className: "st3",
    width: 8.7,
    height: 8.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "9.1,0.6 0.4,0.6 0.4,9.3 9.1,9.3 17.8,9.3 26.5,9.3 17.8,0.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "112.1,0.6 103.4,0.6 103.4,9.3 112.1,9.3 120.8,9.3 129.5,9.3 129.5,0.6 120.8,0.6  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.4,
    y: 0.6,
    className: "st3",
    width: 8.7,
    height: 8.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.7,
    y: 0.6,
    className: "st3",
    width: 8.7,
    height: 8.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "180.9,0.6 172.2,0.6 163.5,0.6 163.5,9.3 172.2,9.3 180.9,9.3 189.6,9.3 189.6,0.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "78.2,0.6 73.3,0.6 73.3,9.3 82,9.3 86.9,9.3 82,4.5  "
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30.6,
    y: 26.7,
    className: "st5",
    width: 8.7,
    height: 8.7
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30.6,
    y: 18,
    className: "st6",
    width: 8.7,
    height: 8.7
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 30.6,
    y: 9.3,
    className: "st7",
    width: 8.7,
    height: 8.7
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 47.9,
    y: 26.7,
    className: "st5",
    width: 8.7,
    height: 8.7
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 47.9,
    y: 18,
    className: "st8",
    width: 8.7,
    height: 8.7
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 47.9,
    y: 9.3,
    className: "st9",
    width: 8.7,
    height: 8.7
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 39.2,
    y: 18,
    className: "st10",
    width: 8.7,
    height: 8.7
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 60.5,
    y: 26.7,
    className: "st5",
    width: 8.7,
    height: 8.7
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 60.5,
    y: 18,
    className: "st8",
    width: 8.7,
    height: 8.7
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 60.5,
    y: 9.3,
    className: "st9",
    width: 8.7,
    height: 8.7
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 0.4,
    y: 26.7,
    className: "st5",
    width: 8.7,
    height: 8.7
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 0.4,
    y: 18,
    className: "st6",
    width: 8.7,
    height: 8.7
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 0.4,
    y: 9.3,
    className: "st7",
    width: 8.7,
    height: 8.7
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "17.8,26.7 17.8,18 26.5,18 "
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 17.8,
    y: 9.3,
    className: "st9",
    width: 8.7,
    height: 8.7
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 9.1,
    y: 18,
    className: "st8",
    width: 8.7,
    height: 8.7
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 112.1,
    y: 26.7,
    className: "st5",
    width: 8.7,
    height: 8.7
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 112.1,
    y: 18,
    className: "st6",
    width: 8.7,
    height: 8.7
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 112.1,
    y: 9.3,
    className: "st7",
    width: 8.7,
    height: 8.7
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 133.4,
    y: 26.7,
    className: "st5",
    width: 8.7,
    height: 8.7
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 133.4,
    y: 18,
    className: "st8",
    width: 8.7,
    height: 8.7
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 133.4,
    y: 9.3,
    className: "st7",
    width: 8.7,
    height: 8.7
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 150.8,
    y: 26.7,
    className: "st11",
    width: 8.7,
    height: 8.7
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 142.1,
    y: 26.7,
    className: "st12",
    width: 8.7,
    height: 8.7
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 163.5,
    y: 26.7,
    className: "st5",
    width: 8.7,
    height: 8.7
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 163.5,
    y: 18,
    className: "st6",
    width: 8.7,
    height: 8.7
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 163.5,
    y: 9.3,
    className: "st7",
    width: 8.7,
    height: 8.7
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 73.3,
    y: 26.7,
    className: "st5",
    width: 8.7,
    height: 8.7
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 73.3,
    y: 18,
    className: "st6",
    width: 8.7,
    height: 8.7
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 73.3,
    y: 9.3,
    className: "st7",
    width: 8.7,
    height: 8.7
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 90.7,
    y: 18,
    className: "st10",
    width: 8.7,
    height: 8.7
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 90.7,
    y: 9.3,
    className: "st13",
    width: 8.7,
    height: 8.7
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 180.9,
    y: 26.7,
    className: "st11",
    width: 8.7,
    height: 8.7
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 172.2,
    y: 26.7,
    className: "st12",
    width: 8.7,
    height: 8.7
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 172.2,
    y: 13.7,
    className: "st9",
    width: 8.7,
    height: 8.7
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "82,9.3 82,18 90.7,18 90.7,13.1 86.9,9.3 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "90.7,26.7 90.7,31.5 94.5,35.4 99.4,35.4 99.4,26.7 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "90.7,31.5 90.7,26.7 85.8,26.7 "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "90.7,26.7 90.7,18 82,18 82,22.9 85.8,26.7 "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "39.2,9.3 30.6,9.3 39.2,0.7 "
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "56.6,9.3 47.9,9.3 47.9,0.7 "
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 39.2,
    y: 0.7,
    className: "st15",
    width: 8.7,
    height: 8.7
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 60.5,
    y: 0.7,
    className: "st15",
    width: 8.7,
    height: 8.7
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "26.5,9.3 17.8,9.3 17.8,0.6 "
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 9.1,
    y: 0.6,
    className: "st15",
    width: 8.7,
    height: 8.7
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 103.4,
    y: 0.6,
    className: "st4",
    width: 8.7,
    height: 8.7
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 120.8,
    y: 0.6,
    className: "st14",
    width: 8.7,
    height: 8.7
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 112.1,
    y: 0.6,
    className: "st15",
    width: 8.7,
    height: 8.7
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 133.4,
    y: 0.6,
    className: "st4",
    width: 8.7,
    height: 8.7
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 163.5,
    y: 0.6,
    className: "st4",
    width: 8.7,
    height: 8.7
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 90.7,
    y: 0.6,
    className: "st14",
    width: 8.7,
    height: 8.7
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 180.9,
    y: 0.6,
    className: "st14",
    width: 8.7,
    height: 8.7
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 172.2,
    y: 0.6,
    className: "st15",
    width: 8.7,
    height: 8.7
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "82,4.5 82,9.3 86.9,9.3 "
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "78.2,0.6 73.3,0.6 73.3,9.3 82,9.3 82,4.5 "
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.ddcffd67.svg";
export { ForwardRef as ReactComponent };